import { FC } from "react";
import "./SelectSeason.css";

const SelectSeason: FC<{
    seasons: string[],
    onSeasonChange: (season: string) => Promise<void>,
    currentSeason: string
}> = ({ onSeasonChange, currentSeason, seasons }) => {

    return <>
        <div className="select-season-title d-flex flex-wrap flex-row align-items-center justify-content-center p-2">
            <div className="h5 my-0 mx-3">
                Stagione
            </div>
        </div>
        <div className="d-flex flex-wrap flex-row">
            {
                seasons.map(season => <div key={season} className={"select-season border d-flex justify-content-center " + (currentSeason === season ? "bg-red" : "")}>
                    <button
                        onClick={async () => await onSeasonChange(season)}
                        className={"select-date-day-button px-0 py-2 border-0 " + (currentSeason === season ? "color-white" : "")}
                    >
                        {season}
                    </button>
                </div>
                )
            }
        </div>

    </>
}

export default SelectSeason;
